import styled from 'styled-components';

export const CloseIcon = styled.button`
  appearance: none;
  background-color: transparent;
  border: none;
  color: ${({ theme }) => theme.yoga.colors.primary};
  cursor: pointer;
  outline: none;
  padding: ${({ theme }) => theme.yoga.spacing.xxxsmall}px;
  position: absolute;
  right: ${({ theme }) => theme.yoga.spacing.medium}px;
  top: ${({ theme }) => theme.yoga.spacing.medium}px;
`;
